import { createContext } from "react";

import { Onboarding } from "@/types";

export type OnboardingContextType = {
  onboarding: Onboarding | null;
  loading: boolean;
};

export const OnboardingContext = createContext<OnboardingContextType>({
  onboarding: null,
  loading: false,
});
